import initialState from './initialState';
import VehicleValidator from '../utils/VehicleValidator';
import Immutable from 'immutable';
import { findInParams } from '../utils/userManager';
import createReducer from './createReducer';

const userInfoLoaded = (state, action) => {
    return state.set('profile', Immutable.fromJS(action.payload));
};

const setEditingStatus = (state, action) => {
    return state.set('isEditingStatus', action.isEditing);
};
const setVehicleNumber = (state, action) => {
    return state
        .set('vehicleNumber', action.vehicleNumber)
        .set('vehicleValidationResults', VehicleValidator.validate(action.vehicleNumber));
};
const saveVehicleNumber = (state, action) => {
    if (VehicleValidator.validate(action.vehicleNumber).get('isValid')) {
        return state.set('vehicleSaved', true);
    }
    return state;
};
const resetVehicleNumber = (state) => {
    return state.set('vehicleSaved', false);
};

const setUserId = (state, action) => state.set('userId', action.userId);

const userLoginFailed = (state, action) => {
    return state.set('loginError', action.payload);
};
const userSessionTerminated = () => {
    return initialState.get('user');
};
const loadingUser = (state) => {
    return state.set('loginError', null);
};

const userFound = (state, action) => {
    const params = action.payload && action.payload.profile && action.payload.profile.params;
    const isFieldAdmin = findInParams(params, 'is_field_admin') === 'true';



    return state
        .set('isLoggedIn', true)
        .set('userId', action.payload.profile.preferred_username)
        .set('name', action.payload.profile.name)
        .set('primaryMarket', findInParams(params, 'primary_market'))
        .set('auxiliaryMarket', findInParams(params, 'auxiliary_market'))
        .set('isFieldAdmin', isFieldAdmin)
        .set('email', action.payload.profile.email)
        // other properties available in params: aux_tech_id, tech_id, manager_tech_id, icoms_user_id
        // for the full onelogin structure see userManager.js
        ;
};

const rehydrate = (state, action) => {
    if (action.payload.user) {
        state = action.payload.user;
    }
    return state.set('stateReady', true);
};

const setChannelData = (state, action) => {
    return state.set('channelData', Immutable.fromJS(action.data));
};

const setAppianChannelData = (state, action) => {
    return state.set('channelDataAppian', Immutable.fromJS(action.data));
};

const handlers = {
    'USER_INFO_LOAD_FINISHED': userInfoLoaded,
    'SET_EDITING_STATUS': setEditingStatus,
    'SET_VEHICLE_NUMBER': setVehicleNumber,
    'SAVE_VEHICLE_NUMBER': saveVehicleNumber,
    'RESET_VEHICLE_SAVED': resetVehicleNumber,
    'SET_USER_ID': setUserId,
    'USER_LOGIN_FAILED': userLoginFailed,
    'redux-oidc/SESSION_TERMINATED': userSessionTerminated,
    'redux-oidc/LOADING_USER': loadingUser,
    'redux-oidc/USER_FOUND': userFound,
    'persist/REHYDRATE': rehydrate,
    'redux-oidc/USER_EXPIRED': userSessionTerminated,
    'SET_CHANNEL_DATA': setChannelData,
    'SET_APPIAN_CHANNEL_DATA': setAppianChannelData,
};

export default createReducer(initialState.get('user'), handlers);



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js